// extracted by mini-css-extract-plugin
export var billingAddress = "_r4-f";
export var contactInfo = "_r4-c";
export var customerInfoContainer = "_r4-b";
export var customerInfoRow = "_r4-9";
export var customerInfoSection = "_r4-a";
export var fullWidthDividerMobile = "_r4-g";
export var imageContainer = "_r4-1";
export var paymentMethod = "_r4-d";
export var priceText = "_r4-6";
export var priceTextMobile = "_r4-7";
export var product = "_r4-0";
export var productImage = "_r4-2";
export var productInfo = "_r4-4";
export var productTitle = "_r4-8";
export var quantityBadge = "_r4-3";
export var quantityText = "_r4-5";
export var shippingAddress = "_r4-e";